<template>
    <div class="lgn-form-item">
        <div class="lgn-form-item-content">
            <div class="lgn-form-item-content-label" :class="{'label-top' : labelPosition == 'top'}">
                <slot name="label"></slot>
            </div>
            <div class="lgn-form-item-content-input" :class="{'item-error': lgnFormItemError}">
                <slot name="input"></slot>
            </div>
        </div>
        <div class="lgn-form-item-error" v-if="lgnFormItemError">
            {{lgnFormItemError}}
        </div>
        <div class="lgn-form-item-custom" v-if="custom">
            <slot name="custom"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'lgnFormItem',
    props: {
        error: null,
        labelPosition: null,
        custom: null
    },
    data(){
        return{

        }
    },
    computed: {
        lgnFormItemError(){
            return this.error
        }
    }
}
</script>